import { Component, Prop, Vue } from 'vue-property-decorator';
import { MasterDataStatusEnum, MasterDataStatusKeyInfo } from '@/items/MasterDataStatus';
import { SelectInputItemInterface } from '@/interfaces/SelectInputItemInterface';

@Component<MasterDataStatusAutocomplete>({})
export default class MasterDataStatusAutocomplete extends Vue {

  // #region @VModel
  // #endregion

  // #region @PropSyncs
  // #endregion

  // #region @Props

  @Prop({ default: 'Master data status' })
  protected label!: string;

  @Prop({
    default: (): SelectInputItemInterface[] => (Object.values(MasterDataStatusEnum) as MasterDataStatusEnum[])
      .map((key) => ({
        id: key,
        name: MasterDataStatusKeyInfo[key]
          && MasterDataStatusKeyInfo[key].label
            ? MasterDataStatusKeyInfo[key].label
            : key,
      }))
  })
  protected items!: SelectInputItemInterface[];

  @Prop({
    default: () => MasterDataStatusKeyInfo[MasterDataStatusEnum.PENDING]
      && MasterDataStatusKeyInfo[MasterDataStatusEnum.PENDING].label
        ? MasterDataStatusKeyInfo[MasterDataStatusEnum.PENDING].label
        : MasterDataStatusEnum.PENDING
  })
  protected placeholder!: string;

  // #endregion

  // #region @Refs
  // #endregion

  // #region Props
  // #endregion

  // #region Plugin props
  // #endregion

  // #region Lifecycle hooks / Init
  // #endregion

  // #region Handlers
  // #endregion

  // #region Helpers
  // #endregion

  // #region API Requests
  // #endregion

  // #region Getters & Setters
  // #endregion

  // #region @Watchers
  // #endregion
}
